import React from 'react';

import { Dashboard } from 'components/Dashboard';

function HomePage() {
  return (
    <Dashboard />
  );
}

export default HomePage;
